module.exports = __webpack_public_path__ + "img/img2.afdad96a.jpg";